import styled from 'styled-components'

import Card from '@ilg-totallymoney/ui/components/Card'
import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'

export const StyledCard = styled(Card)`
    ${focusStylesWithRoundedEdges};
`
